import Vue from 'vue'
import App from './App.vue'
import router from './router'
import eventBus from '@/assets/js/event/EventBus.js'
import store from './store/store-controller/store.js'
import VueMeta from 'vue-meta'
import 'intl'
import 'intl/locale-data/jsonp/en-US'
import DatePicker from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

import { i18n } from './i18n/i18n-controller/i18n.js'
import Bootstrap from 'bootstrap-vue'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.css'

Vue.config.productionTip = false
Vue.use(Bootstrap)
Vue.use(VueMeta)
Vue.use(DatePicker,{datePickerShowDayPopover: false,titlePosition:'center'})

new Vue({
  router,
  store,
  i18n,
  eventBus,
  render: h => h(App)
}).$mount('#app')
